import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {ReplaySubject} from "rxjs";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {User} from "../../../shared/interface/user";
import {Partner} from "../../../shared/interface/partner";
import {FormAddService} from "../../../shared/services/form-add.service";
import {HttpErrorResponse} from "@angular/common/http";
import {first} from "rxjs/operators";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {ChangeFormRowStatusDialogComponent} from "../change-form-row-status-dialog/change-form-row-status-dialog.component";
@Component({
  selector: 'app-add-partner-to-form-dialog',
  templateUrl: './add-partner-to-form-dialog.component.html',
  styleUrls: ['./add-partner-to-form-dialog.component.scss']
})
export class AddPartnerToFormDialogComponent implements OnInit {
  @Output() selectedUser: EventEmitter<User> = new EventEmitter<User>();
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  partnerControl: FormControl;
  partnerForm: FormGroup;
  partner?: Partner;
  processingRequest = false;
  formRowID: string;
  formData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddPartnerToFormDialogComponent>,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snackBar: MatSnackBar,
    private formAddService: FormAddService,
  ) {
    this.formRowID = this.data.uuid;
    this.partnerForm = fb.group({
      partner: this.partnerControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  partnerChanged(partner: Partner): void {
    this.partner = partner;
  }
  partnerUpdate(): void{
    this.processingRequest = true;
    this.formData = {...this.partnerForm?.value};
    this.formAddService.assignPartner(this.formData, this.formRowID)
      .pipe(first())
      .subscribe(() => {
        this.snackBar.open('Pomyślnie zakutalizowano status', '', {duration: 2000});
        this.processingRequest = false;
        this.dialogRef.close(true);
      }, (error: HttpErrorResponse) => {
        this.snackBar.open('Przy aktualizacji wystąpił błąd', error.status.toString(), {duration: 2000});
        this.processingRequest = false;
        this.dialogRef.close(false);
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
